/**
 * [HOOK-SAFETY-ERRORS] Invoke a hook, trap throws, report via onError, fall back to `fallback`.
 * Returns the hook's value when it returns a SafeSvg; returns `fallback` when the hook returns
 * undefined or throws.
 */
export function invokeHook(fn, arg, defaultSvg, phase, report, locator) {
    if (fn === undefined) {
        return { svg: defaultSvg, invoked: false, overridden: false };
    }
    const out = tryCall(() => fn(arg, defaultSvg), phase, report, locator);
    if (out === undefined) {
        return { svg: defaultSvg, invoked: true, overridden: false };
    }
    return { svg: out, invoked: true, overridden: true };
}
/** Variant for zero-default hooks (defs, background, post). */
export function invokeSimpleHook(fn, arg, phase, report) {
    if (fn === undefined) {
        return undefined;
    }
    return tryCall(() => fn(arg), phase, report);
}
function tryCall(fn, phase, report, locator) {
    try {
        return fn();
    }
    catch (error) {
        report?.({ phase, error, ...(locator ?? {}) });
        return undefined;
    }
}
//# sourceMappingURL=hooks.js.map